// src/themes/borders.js

// ==============================|| DEFAULT THEME - BORDERS ||============================== //

const CustomBorders = (theme) => ({
  // default: '1px solid black',
  thick: `1px solid ${theme.palette.grey[400]}`,
  dashed: {
    primary: `4px dashed ${theme.palette.primary.main}`,
    gray: `6px dashed ${theme.palette.grey[300]}`,
  },
});

export default CustomBorders;
